import { Box, Tooltip } from '@mui/material';
import { IconLibrary } from '@product-framework/index';
import getActiveInactiveStatus from '@product-framework/utils/getActiveInactiveStatus';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

function id(original) {
  return original?.id || '';
}

function name(original) {
  const toolTipText = (
    <FormattedMessage
      id="SP_PROFILE_WARNING_MESSAGE"
      defaultMessage="Profile setup issues detected that will prevent the Service Provider from getting Dispatch Requests"
    />
  );
  return (
    <Box sx={{ alignItems: 'center', display: 'flex' }}>
      <Link to={`/serviceproviders/edit/${original?.id}`}>
        {original?.name || ''}
      </Link>
      {original?.hasProfileWarnings && (
        <Tooltip placement="top" arrow title={toolTipText}>
          <IconLibrary.ServiceProviderProfileWarning
            color="warning"
            sx={{ ml: 0.5, fontSize: '20px' }}
          />
        </Tooltip>
      )}
    </Box>
  );
}

function accountNumber(original) {
  return original?.accountNumber || '';
}

function status(original) {
  return getActiveInactiveStatus(original?.status);
}

export { id, name, accountNumber, status };
